import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UrlSignature } from '../common/apiEndpoint';
import { Certification } from './certification';

@Injectable()
export class CertificationService {
  constructor(
    private httpClient: HttpClient,
    private urlSignature: UrlSignature,
  ) {}

  getCertificationbyPersonId(personId: string): Observable<Certification> {
    const url = this.urlSignature.certificationUrl + '/' + personId;
    return this.httpClient
      .get(url)
      .pipe(map((response) => response as Certification));
  }

  saveCertification(certification: Certification): Observable<string> {
    const url = this.urlSignature.certificationUrl;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };
    const data = JSON.stringify(certification);
    return this.httpClient
      .post(url, data, httpOptions)
      .pipe(map((response) => response as string));
  }
}
